import { CommunityAnnouncements } from '@platform/client';
import { Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';

interface DeleteCommunityAnnouncementModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
  page: number;
  limit: number;
}

export const DeleteCommunityAnnouncementModal = (props: DeleteCommunityAnnouncementModalProps) => {
  const { isOpen, onClose, id, page, limit } = props;

  const queryClient = useQueryClient();

  const submitCommunityAnnouncement = CommunityAnnouncements.useDeleteCommunityAnnouncement({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            ...CommunityAnnouncements.getGetCommunityAnnouncementsQueryKey({ page, limit }),
          ],
        });
      },
    },
  });

  const deleteCommunityAnnouncement = async () => {
    submitCommunityAnnouncement.mutate({ data: { id } });

    closeModal();
  };

  const closeModal = () => {
    onClose();
  };

  return (
    <Modal
      variant='dialog'
      title='Delete Community Announcement'
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      ignoreExtraPadding={true}
      primaryCTA={{
        text: 'Delete Community Announcement',
        callback: deleteCommunityAnnouncement,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          Are you sure you want to delete this community announcement?
        </div>
      </div>
    </Modal>
  );
};
